import Modal from '../shared/modal';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TableWrapper = require('../shared/table').default as any;
import { Item } from './item-types';

export interface SecondarySuppliersModalProps {
  item: Item;
  open: boolean;
  setOpen: (open: boolean) => void;
}
export default function SecondarySuppliersModal(
  props: SecondarySuppliersModalProps,
) {
  const columns = [
    {
      id: 'supplier_id',
      label: 'Supplier ID',
    },
    {
      id: 'supplier_name',
      label: 'Name',
    },
    {
      id: 'supplier_part_no',
      label: 'Part #',
    },
    {
      id: 'buyer_name',
      label: 'Buyer',
    },
  ];
  return (
    <Modal
      title={'Supplier Information'}
      open={props.open}
      setOpen={props.setOpen}
    >
      <TableWrapper
        rows={props.item.supplier_details.filter(sd => !!sd.supplier_part_no)}
        columns={columns}
        transformRows
      ></TableWrapper>
    </Modal>
  );
}
